module.exports = __webpack_public_path__ + "static/media/llamada_salida.dcb8cd61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallRecord/llamada_salida.svg
// module id = 1742
// module chunks = 0